import { NOT_FOUND } from 'redux-first-router';
import {
  FORWARD, PRIVACY,
} from '../consts';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case 'ARTICLE_FETCHING':
    case 'DRAFT_FETCHING':
    case 'LANDER_FETCHING':
    case 'PAGE_FETCHING':
      return {
        ...state,
        isLoading: true,
        // shouldDestroyAds: false,
      };
    case 'AUTHOR_FETCHED':
    case 'ARTICLE_FETCHED':
    case 'DRAFT_FETCHED':
    case 'LANDER_FETCHED':
    case 'PAGE_FETCHED':
		    return {
		    	isLoading: false,
        // shouldDestroyAds: true,
		    	...action.payload.data,
		    };
      		break;
    case 'CORPORATE_FETCHED':
      return { pageType: 'corporate' };
    case 'PRIVACY_FETCHED':
      return { pageType: PRIVACY };
    default:
      return state;
  }
};
